<div class="container">
  <div class="wrapper">
    <h1>Search Tips</h1>
    <p class="subtitle">
      The search bar filters products by title. Words are matched as prefixes, so
      typing <code>key</code> matches "keyboard", "keychain", etc.
    </p>

    <h2>Basics</h2>
    <table class="example-table">
      <tr>
        <th>You type</th>
        <th>What it does</th>
      </tr>
      <tr>
        <td><code>sony headphones</code></td>
        <td>Both words must appear (AND). Order doesn't matter.</td>
      </tr>
      <tr>
        <td><code>headphones OR earbuds</code></td>
        <td>Either word can match. <code>OR</code> must be uppercase.</td>
      </tr>
      <tr>
        <td><code>-wireless</code></td>
        <td>Exclude products containing "wireless".</td>
      </tr>
      <tr>
        <td><code>"coffee maker"</code></td>
        <td>Exact phrase &mdash; words must appear next to each other in that order.</td>
      </tr>
    </table>

    <h2>Combining operators</h2>
    <table class="example-table">
      <tr>
        <th>You type</th>
        <th>What it does</th>
      </tr>
      <tr>
        <td><code>sony -wireless</code></td>
        <td>Products with "sony" but without "wireless".</td>
      </tr>
      <tr>
        <td><code>(headphones OR earbuds) sony</code></td>
        <td>Must have "sony" AND either "headphones" or "earbuds".</td>
      </tr>
      <tr>
        <td><code>"usb c" hub -hdmi</code></td>
        <td>Exact phrase "usb c" AND "hub", excluding "hdmi".</td>
      </tr>
      <tr>
        <td><code>(iphone OR samsung) case -wallet</code></td>
        <td>Cases for iPhone or Samsung, excluding wallet cases.</td>
      </tr>
    </table>

    <h2>Filters</h2>
    <p class="subtitle">
      Open the left menu to filter by price range, savings percentage, price difference,
      sort order, and category. Combine filters with a search term to narrow results further.
    </p>

    <div class="note">
      <strong>Tip:</strong> Use fewer words for better results. Searching <code>keyboard</code>
      finds more than <code>mechanical gaming keyboard</code> because sellers don't always
      include every descriptor in their titles.
    </div>

    <a routerLink="/deals" class="back-link">&larr; Back to deals</a>
  </div>
</div>
